<script setup>

</script>

<template>
    <thead class="border-b">
        <tr>
            <slot/>
        </tr>
    </thead>
</template>
